import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Llamarlo por su nombre (sin discutir)",
    opening: localizedGenderNode(
      [
      "Hoy lo reconozco: es perfeccionismo. No solo “altos estándares” — es miedo."
    ],
      [
      "Hoy lo reconozco: es perfeccionismo. No solo “altos estándares” — es miedo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración lenta.",
      "En mi interior: “Tengo miedo de equivocarme — por eso exijo perfección.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración lenta.",
      "En mi interior: “Tengo miedo de equivocarme — por eso exijo perfección.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué quiero que sea “perfecto” ahora mismo?\n[Escribe aquí]",
      "¿Qué temo que pase si es solo “suficiente”?\n[Escribe aquí]",
      "¿Dónde siento este miedo en el cuerpo?\n[Escribe aquí]"
    ],
      [
      "¿Qué quiero que sea “perfecto” ahora mismo?\n[Escribe aquí]",
      "¿Qué temo que pase si es solo “suficiente”?\n[Escribe aquí]",
      "¿Dónde siento este miedo en el cuerpo?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Hoy no lucho contra el perfeccionismo. Lo reconozco."
    ],
      [
      "Cierre",
      "Hoy no lucho contra el perfeccionismo. Lo reconozco."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: una respiración + la frase: “La perfección es miedo disfrazado.”",
      "Una vez hoy: una respiración + la frase: “La perfección es miedo disfrazado.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Hecho vs. exigencia (CBT suave)",
    opening: localizedGenderNode(
      [
      "Hoy reviso qué es realmente necesario y qué exijo para no sentirme expuesto/a."
    ],
      [
      "Hoy reviso qué es realmente necesario y qué exijo para no sentirme expuesto/a."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “No todo tiene que ser 100%.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “No todo tiene que ser 100%.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué se requiere realmente aquí? (mínimo real)\n[Escribe aquí]",
      "¿Cuál es la exigencia perfeccionista por encima de eso?\n[Escribe aquí]",
      "¿Qué verdad suave es posible aquí? (una frase)\n[Escribe aquí]"
    ],
      [
      "¿Qué se requiere realmente aquí? (mínimo real)\n[Escribe aquí]",
      "¿Cuál es la exigencia perfeccionista por encima de eso?\n[Escribe aquí]",
      "¿Qué verdad suave es posible aquí? (una frase)\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La exigencia alta no siempre es calidad — a veces es miedo."
    ],
      [
      "Cierre",
      "La exigencia alta no siempre es calidad — a veces es miedo."
    ]
    ),
    action: localizedGenderNode(
      "Defino un “mínimo real” para una tarea.",
      "Defino un “mínimo real” para una tarea."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Miedo a equivocarse (y lo que dice de mí)",
    opening: localizedGenderNode(
      [
      "Hoy toco el miedo al error sin dejar que me detenga."
    ],
      [
      "Hoy toco el miedo al error sin dejar que me detenga."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué error me da más miedo cometer?\n[Escribe aquí]",
      "¿Qué me digo que significaría sobre mí si lo cometo?\n[Escribe aquí]",
      "¿Qué otra verdad podría existir? (Error = …)\n[Escribe aquí]"
    ],
      [
      "¿Qué error me da más miedo cometer?\n[Escribe aquí]",
      "¿Qué me digo que significaría sobre mí si lo cometo?\n[Escribe aquí]",
      "¿Qué otra verdad podría existir? (Error = …)\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Un error es un evento. No una identidad."
    ],
      [
      "Cierre",
      "Un error es un evento. No una identidad."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy digo: “Está permitido equivocarse en el camino.”",
      "Una vez hoy digo: “Está permitido equivocarse en el camino.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Procrastinación como “protección”",
    opening: localizedGenderNode(
      [
      "Hoy entiendo que la procrastinación no es pereza, es protección."
    ],
      [
      "Hoy entiendo que la procrastinación no es pereza, es protección."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “No soy perezoso/a. Tengo miedo.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “No soy perezoso/a. Tengo miedo.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué estoy postergando ahora?\n[Escribe aquí]",
      "¿De qué me protege esta postergación? (crítica / vergüenza / fracaso / exposición)\n[Escribe aquí]",
      "¿Qué versión pequeña y posible de empezar existe?\n[Escribe aquí]"
    ],
      [
      "¿Qué estoy postergando ahora?\n[Escribe aquí]",
      "¿De qué me protege esta postergación? (crítica / vergüenza / fracaso / exposición)\n[Escribe aquí]",
      "¿Qué versión pequeña y posible de empezar existe?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Cuando respeto el miedo, puedo empezar pequeño."
    ],
      [
      "Cierre",
      "Cuando respeto el miedo, puedo empezar pequeño."
    ]
    ),
    action: localizedGenderNode(
      "Hago un inicio de 2 minutos. Solo 2.",
      "Hago un inicio de 2 minutos. Solo 2."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "“O perfecto o nada”",
    opening: localizedGenderNode(
      [
      "Hoy reconozco el pensamiento extremo y devuelvo el punto medio."
    ],
      [
      "Hoy reconozco el pensamiento extremo y devuelvo el punto medio."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “También existe el medio.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “También existe el medio.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde pienso “o perfecto o nada”?\n[Escribe aquí]",
      "¿Cuál es el costo de esta extremidad?\n[Escribe aquí]",
      "¿Cómo suena una versión intermedia? (una frase)\n[Escribe aquí]"
    ],
      [
      "¿Dónde pienso “o perfecto o nada”?\n[Escribe aquí]",
      "¿Cuál es el costo de esta extremidad?\n[Escribe aquí]",
      "¿Cómo suena una versión intermedia? (una frase)\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El medio es donde se construye la vida."
    ],
      [
      "Cierre",
      "El medio es donde se construye la vida."
    ]
    ),
    action: localizedGenderNode(
      "Elijo una versión del 70% para una tarea.",
      "Elijo una versión del 70% para una tarea."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "El crítico interno con el látigo",
    opening: localizedGenderNode(
      [
      "Hoy noto el tono y dejo de permitirle dirigir."
    ],
      [
      "Hoy noto el tono y dejo de permitirle dirigir."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “El tono no tiene que ser violento.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “El tono no tiene que ser violento.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me dice el crítico para “motivarme”?\n[Escribe aquí]",
      "¿Qué efecto tiene en mi cuerpo y energía?\n[Escribe aquí]",
      "¿Cómo hablaría a un amigo querido para ayudarlo a avanzar?\n[Escribe aquí]"
    ],
      [
      "¿Qué me dice el crítico para “motivarme”?\n[Escribe aquí]",
      "¿Qué efecto tiene en mi cuerpo y energía?\n[Escribe aquí]",
      "¿Cómo hablaría a un amigo querido para ayudarlo a avanzar?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El látigo no crea estabilidad. Crea miedo."
    ],
      [
      "Cierre",
      "El látigo no crea estabilidad. Crea miedo."
    ]
    ),
    action: localizedGenderNode(
      "Reemplazo una frase violenta por una frase humana.",
      "Reemplazo una frase violenta por una frase humana."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Experimento de progreso: 10% es victoria",
    opening: localizedGenderNode(
      [
      "Hoy practico una acción pequeña aunque no sea perfecta."
    ],
      [
      "Hoy practico una acción pequeña aunque no sea perfecta."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué meta grande me congela?\n[Escribe aquí]",
      "¿Cuál es el 10% que puedo hacer hoy?\n[Escribe aquí]",
      "¿Qué quiero demostrarme con ese 10%?\n[Escribe aquí]"
    ],
      [
      "¿Qué meta grande me congela?\n[Escribe aquí]",
      "¿Cuál es el 10% que puedo hacer hoy?\n[Escribe aquí]",
      "¿Qué quiero demostrarme con ese 10%?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No necesito motivación para empezar. Necesito empezar."
    ],
      [
      "Cierre",
      "No necesito motivación para empezar. Necesito empezar."
    ]
    ),
    action: localizedGenderNode(
      "Hago mi 10%. Eso es todo.",
      "Hago mi 10%. Eso es todo."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Tolerar la incertidumbre (ACT)",
    opening: localizedGenderNode(
      [
      "Hoy practico actuar con incertidumbre."
    ],
      [
      "Hoy practico actuar con incertidumbre."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “La incertidumbre es el precio de vivir.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “La incertidumbre es el precio de vivir.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué temo que ocurra si no es perfecto?\n[Escribe aquí]",
      "Práctica de un minuto: dejo que el miedo esté sin arreglarlo.\n¿Qué pasó después del minuto?\n[Escribe aquí]",
      "¿Qué aprendí sobre la ola?\n[Escribe aquí]"
    ],
      [
      "¿Qué temo que ocurra si no es perfecto?\n[Escribe aquí]",
      "Práctica de un minuto: dejo que el miedo esté sin arreglarlo.\n¿Qué pasó después del minuto?\n[Escribe aquí]",
      "¿Qué aprendí sobre la ola?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Soy valiente no porque no haya miedo, sino porque actúo con él."
    ],
      [
      "Cierre",
      "Soy valiente no porque no haya miedo, sino porque actúo con él."
    ]
    ),
    action: localizedGenderNode(
      "Un minuto solamente. Constancia > fuerza.",
      "Un minuto solamente. Constancia > fuerza."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "“Qué dirán” y la vergüenza",
    opening: localizedGenderNode(
      [
      "Hoy veo que el perfeccionismo suele ser miedo a exponerse."
    ],
      [
      "Hoy veo que el perfeccionismo suele ser miedo a exponerse."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Quién “vive en mi cabeza” cuando quiero ser perfecto/a?\n[Escribe aquí]",
      "¿Qué temo que juzguen de mí?\n[Escribe aquí]",
      "¿Qué verdad suave elijo sobre mí hoy?\n[Escribe aquí]"
    ],
      [
      "¿Quién “vive en mi cabeza” cuando quiero ser perfecto/a?\n[Escribe aquí]",
      "¿Qué temo que juzguen de mí?\n[Escribe aquí]",
      "¿Qué verdad suave elijo sobre mí hoy?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No necesito ser perfecto/a para ser digno/a."
    ],
      [
      "Cierre",
      "No necesito ser perfecto/a para ser digno/a."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: “Lo hago por mí, no por el jurado.”",
      "Una vez hoy: “Lo hago por mí, no por el jurado.”"
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Compasión en lugar de presión",
    opening: localizedGenderNode(
      [
      "Hoy me sostengo como a alguien que amo."
    ],
      [
      "Hoy me sostengo como a alguien que amo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “Puedo avanzar sin pisarme.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “Puedo avanzar sin pisarme.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué diría a un amigo querido paralizado por el perfeccionismo?\n[Escribe aquí]",
      "¿Qué frase estoy dispuesto/a a decirme a mí?\n[Escribe aquí]",
      "¿Dónde me cuesta más ser amable conmigo?\n[Escribe aquí]"
    ],
      [
      "¿Qué diría a un amigo querido paralizado por el perfeccionismo?\n[Escribe aquí]",
      "¿Qué frase estoy dispuesto/a a decirme a mí?\n[Escribe aquí]",
      "¿Dónde me cuesta más ser amable conmigo?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La compasión no baja el estándar, baja el miedo."
    ],
      [
      "Cierre",
      "La compasión no baja el estándar, baja el miedo."
    ]
    ),
    action: localizedGenderNode(
      "Mano en el pecho/vientre + mi frase amable una vez.",
      "Mano en el pecho/vientre + mi frase amable una vez."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Límites al tiempo y a los bucles",
    opening: localizedGenderNode(
      [
      "Hoy pongo un límite al pulido infinito."
    ],
      [
      "Hoy pongo un límite al pulido infinito."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “Suficiente también es una decisión.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “Suficiente también es una decisión.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde me quedo puliendo sin fin?\n[Escribe aquí]",
      "¿Qué límite de tiempo pequeño pondré? (15–30 min)\n[Escribe aquí]",
      "¿Qué temo que pase si paro a tiempo?\n[Escribe aquí]"
    ],
      [
      "¿Dónde me quedo puliendo sin fin?\n[Escribe aquí]",
      "¿Qué límite de tiempo pequeño pondré? (15–30 min)\n[Escribe aquí]",
      "¿Qué temo que pase si paro a tiempo?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Un límite protege la vida, no renuncia a la calidad."
    ],
      [
      "Cierre",
      "Un límite protege la vida, no renuncia a la calidad."
    ]
    ),
    action: localizedGenderNode(
      "Trabajo con tiempo limitado y paro a tiempo.",
      "Trabajo con tiempo limitado y paro a tiempo."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Practicar la “versión uno”",
    opening: localizedGenderNode(
      [
      "Hoy practico sacar una versión uno sin disculparme."
    ],
      [
      "Hoy practico sacar una versión uno sin disculparme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué llevo esperando “estar listo/a” desde hace tiempo?\n[Escribe aquí]",
      "¿Qué sería una versión uno mínima?\n[Escribe aquí]",
      "¿Qué pasaría realmente si saco la versión uno?\n[Escribe aquí]"
    ],
      [
      "¿Qué llevo esperando “estar listo/a” desde hace tiempo?\n[Escribe aquí]",
      "¿Qué sería una versión uno mínima?\n[Escribe aquí]",
      "¿Qué pasaría realmente si saco la versión uno?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La versión uno no es vergüenza. Es comienzo."
    ],
      [
      "Cierre",
      "La versión uno no es vergüenza. Es comienzo."
    ]
    ),
    action: localizedGenderNode(
      "Saco algo como versión uno (aunque sea solo para mí).",
      "Saco algo como versión uno (aunque sea solo para mí)."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Construir identidad de alguien que avanza",
    opening: localizedGenderNode(
      [
      "Hoy elijo ser alguien que avanza, no que demuestra."
    ],
      [
      "Hoy elijo ser alguien que avanza, no que demuestra."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “Estoy en camino.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “Estoy en camino.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué valor quiero que me guíe? (crecimiento / verdad / calma / valentía)\n[Escribe aquí]",
      "¿Qué hábito pequeño sirve ese valor esta semana?\n[Escribe aquí]",
      "¿Qué me prometo en un día bloqueado?\n[Escribe aquí]"
    ],
      [
      "¿Qué valor quiero que me guíe? (crecimiento / verdad / calma / valentía)\n[Escribe aquí]",
      "¿Qué hábito pequeño sirve ese valor esta semana?\n[Escribe aquí]",
      "¿Qué me prometo en un día bloqueado?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No espero ser perfecto/a para ser yo."
    ],
      [
      "Cierre",
      "No espero ser perfecto/a para ser yo."
    ]
    ),
    action: localizedGenderNode(
      "Planifico un paso pequeño para la próxima semana y lo pongo en la agenda.",
      "Planifico un paso pequeño para la próxima semana y lo pongo en la agenda."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave (salir de la jaula)",
    opening: localizedGenderNode(
      [
      "Hoy cierro el viaje no con victoria, sino con libertad."
    ],
      [
      "Hoy cierro el viaje no con victoria, sino con libertad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “Elijo la vida.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “Elijo la vida.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué entendí sobre mi perfeccionismo?\n[Escribe aquí]",
      "¿Qué cambió en mí, aunque sea un poco?\n[Escribe aquí]",
      "Frase de retorno para días difíciles (corta y clara):\n[Escribe aquí]"
    ],
      [
      "¿Qué entendí sobre mi perfeccionismo?\n[Escribe aquí]",
      "¿Qué cambió en mí, aunque sea un poco?\n[Escribe aquí]",
      "Frase de retorno para días difíciles (corta y clara):\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final del viaje",
      "No cancelo mi deseo de calidad.",
      "Cancelo la violencia que me mantiene bloqueado/a.",
      "Sigo caminando —",
      "despacio, en silencio, conmigo.",
      "Y eso es fuerza."
    ],
      [
      "Cierre final del viaje",
      "No cancelo mi deseo de calidad.",
      "Cancelo la violencia que me mantiene bloqueado/a.",
      "Sigo caminando —",
      "despacio, en silencio, conmigo.",
      "Y eso es fuerza."
    ]
    ),
    action: localizedGenderNode(
      "Elijo una acción que simbolice “empecé”: 10 minutos de trabajo / enviar / abrir un archivo.",
      "Elijo una acción que simbolice “empecé”: 10 minutos de trabajo / enviar / abrir un archivo."
    ),
  },
].map(buildNormalizedDay);

export const perfectionismFearOfMistakesProcrastinationBlueprintEs = buildNormalizedPilotBlueprint({
  id: "perfectionism_fear_of_mistakes_procrastination_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "perfectionism_fear_of_mistakes_procrastination",
  category: "general",
  journeyName: {
    he: "פרפקציוניזם שמוביל לפחד מטעויות ודחיינות",
    en: "Perfectionism Leading to Fear of Mistakes and Procrastination",
    es: "Perfeccionismo que lleva al miedo a equivocarse y a la procrastinación",
  },
  days,
});

export default perfectionismFearOfMistakesProcrastinationBlueprintEs;
